//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { Observable, lastValueFrom, map, of } from 'rxjs';
import { TypeRecurringDTO } from 'src/app/core/models/system/type/type-recurring.dto';

@Injectable({ providedIn: 'root' })

export class TypesRecurringService {
  
  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TypeRecurringDTO[]>(environment.eSimApi + eSimApiPaths.TypesRecurring)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescriptionByFrequencyCodes(frequencyCodes: string[]): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TypeRecurringDTO[]>(environment.eSimApi +
                                                            eSimApiPaths.TypesRecurring +
                                                            "?activeOnly=true")
      .pipe(
        map(x => x.filter(t => frequencyCodes.includes(t.frequencyCode))
                  .map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(typeRecurring: TypeRecurringDTO) {
    return {id: typeRecurring.id, description: typeRecurring.frequency};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
}
